const Thumbnail = ({ contest }) => {
  return (
    <a href={`/song/1/${contest._id}`} className="relative h-56 w-56 min-w-[180px] min-h-[180px] cursor-pointer transition-transform duration-200 ease-out md:hover:scale-110">
      <img
        src={contest.imgLink}
        layout="fill"
        className="rounded-sm object-cover md:rounded"
        alt={contest.contestName}
      />
    </a>
  );
};

export default Thumbnail;
